import { useMutation } from 'react-query';
import { ActionStatus } from 'mdello-client-ts';
import { getClient } from 'src/util/mdello-instance';
import { useNotification } from 'src/providers/notificationsProvider';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { UseMutationInterface } from 'src/reactQuery/customers/mutations/interfaces/useUpdateCustomer.interface';

const updateVacations = async (requestId: string, status: ActionStatus): Promise<void> => {
  const currentProject: any = getDataFromLocalStorage(LocalStorageKey.CURRENT_PROJECT);
  if (!currentProject) return;

  await getClient()?.updateAction(currentProject._id!, requestId, { status });
};

export const useUpdateVacations = ({ onError, onSuccess }: UseMutationInterface) => {
  const { notify } = useNotification();

  return useMutation(
    // @ts-ignore-next-line
    (params: { requestId: string; status: ActionStatus }) => {
      updateVacations(params.requestId, params.status);
    },
    {
      onError: () => {
        notify({ message: 'something went wrong', severity: 'error' });
        if (onError) {
          onError();
        }
      },
      onSuccess: () => {
        if (onSuccess) {
          onSuccess();
        }
      }
    }
  );
};
